<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat, text-xs-center)
            breadcrumb(back='page7-2')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero contratar mi Crédito Hipotecario!
            v-layout.px-4(row, justify-start)
              v-flex(xs6)
                v-card(flat)
                  v-card-media(height='576px', src='assets/TCH-L2.7-8-9-subportada.jpg')
              v-flex(xs6)
                v-card.ml-0.pl-0(flat, text-xs-start)
                  v-card-text.label16tt.withDividerLeft.ml-0.pl-0(style='color:#F7893B')
                    | CIERRE DEL TEMA
                  v-card-text.titulo36Book.ml-0.pl-0
                    | ¡Estás listo para elegir el Crédito Hipotecario que más te conviene!
                  v-card-text.parrafoDestacadoB.ml-0.pl-0.pt-5
                    | Ya tienes un panorama claro de qué crédito se ajusta más a tus necesidades, así como los requisitos generales a la hora de solicitarlo. Afianza estos nuevos conocimientos con la siguiente actividad y valida que estás listo para contratarlo.
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button ', color='primary ', @click.prevent="nextChapter( 'page10-1') ")
                | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false,
      questions: 5
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    },
    evaluation() {
      var quiz_prefix = 'page1';
      var quiz_results = Object.keys(this.$parent.results)
        .filter(key => key.indexOf(quiz_prefix) > -1)
        .reduce((obj, key) => {
          obj[key] = this.$parent.results[key];
          return obj;
        }, {});
      return (100 / this.questions * Object.values(quiz_results).reduce((a, b) => a + b, 0)).toFixed(0);
    }
  }
};
</script>
